import {
  TransactionType,
  useBuySellStore,
} from "@/reducers/transactionReducer";
import { PaymentTypes } from "@/utils/currencies";

import { InteracBuyInstructions } from "./BuyInstructions";
import { InteracRequestInstructions } from "./InteracRequestInstructions";
import { SellTransactionInstructions } from "./SellTransactionInstructions";

type TransactionInstructionsProps = {
  orderId: string;
  wallet: string;
};

export const TransactionInstructions = ({
  orderId,
  wallet,
}: TransactionInstructionsProps) => {
  const transactionType = useBuySellStore.use.transactionType();
  const requestType = useBuySellStore.use.requestType();

  if (transactionType === TransactionType.SELL) {
    return (
      <div data-testid="container-transaction-sell-instructions">
        <SellTransactionInstructions sourceWallet={wallet} orderId={orderId} />
      </div>
    );
  }
  if (requestType === PaymentTypes.REQUEST) {
    return (
      <div data-testid="container-transaction-interac-request">
        <InteracRequestInstructions wallet={wallet} orderId={orderId} />
      </div>
    );
  }
  return (
    <div data-testid="container-transaction-interac-buy">
      <InteracBuyInstructions wallet={wallet} orderId={orderId} />
    </div>
  );
};
